import { SensitiveApprovalPhase, type SensitiveApprovalResponse } from './types'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function isSensitiveApprovalPayload(value: unknown): value is SensitiveApprovalResponse {
  return isRecord(value) && value.needApproval === true && typeof value.phase === 'string'
}

export function isRequireConfirmApproval(value: unknown): value is SensitiveApprovalResponse {
  return isSensitiveApprovalPayload(value) && value.phase === SensitiveApprovalPhase.RequireConfirm
}

export function isPendingApproval(value: unknown): value is SensitiveApprovalResponse {
  return isSensitiveApprovalPayload(value) && value.phase === SensitiveApprovalPhase.Pending
}
